module.exports = __webpack_public_path__ + "fonts/overvoice.b7de31d.woff";